/**
 * @param {any} args The argument you're trying to inspect
 * @returns {Boolean} Return true if argument is a string
 */
export function isString(args: any): args is string {
  return typeof args === 'string';
}
